var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-dropzone',{ref:"dropzone",attrs:{"id":"dropzone","options":_vm.dropzoneOptions,"use-custom-slot":true},on:{"vdropzone-file-added":_vm.addFile}},[_c('div',[_vm._v("Click to select a file from your system or drag and drop the file here")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }